import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=6e72f7be&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=6e72f7be&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e72f7be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e72f7be')) {
      api.createRecord('6e72f7be', component.options)
    } else {
      api.reload('6e72f7be', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=6e72f7be&scoped=true", function () {
      api.rerender('6e72f7be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Main.vue"
export default component.exports